import { Component, inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SnackbarMode } from '@eiq/ui';
import { InputType } from '@empathy/survey/base';

import { InputTypeLabels } from '../../../../models/input-type-labels.constants';
import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';
import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-input-settings',
  templateUrl: 'input-settings.component.html',
  styleUrls: ['./input-settings.component.scss', './_input-settings-theme.component.scss']
})
export class InputSettingsComponent implements OnInit {
  inputType = InputType;
  inputTypeLabels = InputTypeLabels;

  surveyEditor$ = inject(SurveyEditorService).surveyEditor$;

  private conditionalsService = inject(SurveyConditionalsService);
  private snackBar = inject(MatSnackBar);

  ngOnInit(): void {
    this.surveyEditor$()
      .activeQuestion.get('inputType')
      .valueChanges.subscribe(() => {
        const affectedQuestions = this.surveyEditor$().affectedQuestionsOnConditional;

        if (affectedQuestions.length === 0) {
          return;
        }

        this.conditionalsService.removeAffectedConditions();

        this.snackBar.open(`Conditions on ${affectedQuestions.join(', ')} affected by this question were removed`, 'Ok', {
          verticalPosition: 'top',
          panelClass: SnackbarMode.Alert
        });
      });
  }
}
